import { useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from '_common/hooks';

import { openAndUpdateModal } from '_common/modals/ModalsSlice';
import IntlErrorBoundary from '_common/components/IntlErrorBoundary/IntlErrorBoundary';
import { EmptyState } from '@ets/design-system';

import { useGetTagsListQuery } from './TagsApi';
import TagList from './TagList';
import TagsHeading from './TagsHeading';

const Tags = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { data: tags } = useGetTagsListQuery();

  const [search, setSearch] = useState('');

  const testId = 'tenant-settings-tags';

  return (
    <>
      <IntlErrorBoundary
        fallbackType="sectionHeading"
        mockProps={{ size: 'l', margin: '3rem 0 0 0' }}
      >
        <TagsHeading search={search} onSearchChange={setSearch} testId={testId} />
      </IntlErrorBoundary>

      {tags?.list && tags.list.length > 0 ? (
        <IntlErrorBoundary size="xl" style={{ margin: '10rem 0 0 0' }}>
          <TagList search={search} testId={testId} />
        </IntlErrorBoundary>
      ) : (
        <EmptyState
          className="mx-auto mt-24 w-204"
          size="l"
          cta={{
            children: intl.formatMessage({ id: 'ADD_NEW_TAG' }),
            onClick: () =>
              dispatch(
                openAndUpdateModal({
                  modal: 'CreateNewTagModal',
                  data: {},
                }),
              ),
          }}
          title={intl.formatMessage({ id: 'NO_TAGS_IN_TENANT' })}
          testId={testId}
          description={intl.formatMessage({ id: 'TENANT_SETTINGS_TAGS_EMPTY_STATE' })}
        />
      )}
    </>
  );
};

export default Tags;
